import type { IconProps } from '.';

/**
 * Mute Icon SVG component.
 *
 * IMPORTANT:
 * Importing a SVG directly tells the compiler to use Webpack, thus including the whole file in the bundle.
 * By using a component instead, we can leverage server components and return HTML directly from the server.
 */

const MuteIcon = ({ className }: IconProps) => (
  <svg
    role="presentation"
    aria-hidden="true"
    focusable="false"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.55556 8H2V16H6.55556L11 21V3L6.55556 8ZM10 5.6302L7.00462 9H3V15H7.00462L10 18.3698V5.6302Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.6464 14.6464L20.6464 8.64645L21.3536 9.35355L15.3536 15.3536L14.6464 14.6464Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.3536 8.64645L21.3536 14.6464L20.6464 15.3536L14.6464 9.35355L15.3536 8.64645Z"
      fill="white"
    />
  </svg>
);

export default MuteIcon;
